import { render, staticRenderFns } from "./MobileScroll.vue?vue&type=template&id=9206e348&scoped=true"
import script from "./MobileScroll.vue?vue&type=script&lang=js"
export * from "./MobileScroll.vue?vue&type=script&lang=js"
import style0 from "./MobileScroll.vue?vue&type=style&index=0&id=9206e348&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9206e348",
  null
  
)

export default component.exports